import axios from "axios"
import { t } from "i18next"

export type SubscriptionRenewalType = "monthly" | "one_time"

export interface SubscriptionPlanSchema {
    id: string
    name: string
    price: number
    megabytes_of_storage: number
    lite_tokens: number
    pro_tokens: number
    pages: number
    translation_characters: number
    workflows_runs: number
    is_custom?: boolean
    payment_link_url?: string
    type: SubscriptionPlanType
    metadata?: string[]
    renewal_type?: SubscriptionRenewalType
    validity_days?: number | null
}

export const enum SubscriptionPlanType {
    free = "free",
    pro = "pro",
    pro_plus = "pro_plus",
    enterprise = "enterprise",
}

export type Subscription = {
    id: string
    status: string
    user_id: string
    plan_id: string
    start_date_utc: string
    end_date_utc?: string
    renewal_type?: SubscriptionRenewalType
    is_cancelled: boolean
    plan?: SubscriptionPlanSchema
}
export const getSubscription = async (): Promise<Subscription> => {
    try {
        const response = await axios.get(`/subscriptions/active`)

        if (!response.data) {
            throw new Error(t("Could not get subscription"))
        }

        return response.data
    } catch (error) {
        throw new Error(t("Could not get subscription"))
    }
}

export const cancelSubscription = async (): Promise<string> => {
    try {
        const response = await axios.post(`/subscriptions/active/cancel`)

        if (response.status !== 200) {
            throw new Error(t("Could not cancel subscription"))
        }

        return response.data
    } catch (error) {
        throw new Error(t("Could not cancel subscription"))
    }
}

export const renewSubscription = async (): Promise<string> => {
    try {
        const response = await axios.post(`/subscriptions/active/renew`)

        if (response.status !== 200) {
            throw new Error(t("Could not renew subscription"))
        }

        return response.data
    } catch (error) {
        throw new Error(t("Could not renew subscription"))
    }
}

export const getSubscriptionsPlans = async (): Promise<SubscriptionPlanSchema[]> => {
    try {
        const response = await axios.get(`/subscription-plans`)

        if (!response.data) {
            throw new Error(t("Could not get subscription"))
        }

        return response.data
    } catch (error) {
        throw new Error(t("Could not get subscription"))
    }
}
